// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_cx-6";
export var emphasizeQuantity = "_cx-3";
export var flatBottomCorners = "_cx-5";
export var productImage = "_cx-0";
export var quantityContainer = "_cx-2";
export var tooltip = "_cx-1";
export var wrapAndEllipsesOverflow = "_cx-4";